// extracted by mini-css-extract-plugin
export var brand = "_a4-9";
export var compact = "_a4-6";
export var extraSmall = "_a4-7";
export var icon = "_a4-0";
export var large = "_a4-4";
export var light = "_a4-1";
export var medium = "_a4-5";
export var outline = "_a4-b";
export var primaryDark = "_a4-a";
export var primaryLight = "_a4-8";
export var primaryModern = "_a4-c";
export var success = "_a4-2";
export var successSolid = "_a4-3";